export default __webpack_public_path__ + "static/media/login.367a46fc.svg";